import SectionPanel from "components/panels/SectionPanel/SectionPanel";
import React from "react";
import { FormSection, Section, InPageEditableSectionField, TwoColumnInPageEditableSectionField } from "./types";
import InPageEditableFieldWithLabel from "./InPageEditableFieldWithLabel";
import { SectionTemplateHeader } from "./SectionTemplateHeader";
import classNames from "classnames";

interface MainSectionTemplateProps {
  isInPageEditable: boolean;
  compact?: boolean;
  sections: Array<Section>;
  noPanels?: boolean;
  displayEmptyValues?: boolean;

  wideLabel?: boolean;
}

export const isFieldHidden = (field: InPageEditableSectionField | TwoColumnInPageEditableSectionField, isInPageEditable: boolean, displayEmptyValues?: boolean): boolean => {
  if (field.hidden) return true;
  if (!isInPageEditable && field.isEmpty && !displayEmptyValues) return true;

  return false;
}

// TODO: We will eventually need to get rid of LabelledDivRow and associated classNames
//  Everywhere where we use it we should use this instead
// TODO: We can get rid of Section (the old one we use in old detail pages)
// TODO: We can get rid of RecordInformationOld component
export const SectionTemplate = (props: MainSectionTemplateProps) => {
  const { isInPageEditable, compact, sections, displayEmptyValues } = props;

  const isFieldHidden = (field: InPageEditableSectionField | TwoColumnInPageEditableSectionField): boolean => {
    if (field.hidden) return true;
    if (!isInPageEditable && field.isEmpty && !displayEmptyValues) return true;

    return false;
  }

  const visibleSections = sections
    .filter(section => !section.hidden)
    .filter(section => {
      if(section.type === "custom") return true;

      // If all fields in a section are invisible, we don't render the section
      return section.fields.some(field => !isFieldHidden(field));
    })


  const  renderFormSectionFields = (fields: Array<InPageEditableSectionField | TwoColumnInPageEditableSectionField>) => {
    const visibleFields = fields.filter(field => !isFieldHidden(field));
    return <div className={classNames("main-section-template-grid", {
      "main-section-template-grid-wide": props.wideLabel
    })}>
      {visibleFields.map(field => <InPageEditableFieldWithLabel key={field.key} field={field} compact={compact} />)}
    </div>
  }

  const renderFormSection = (section: FormSection) => {
    if (props.noPanels) {
      return <React.Fragment key={section.key}>
        {renderFormSectionFields(section.fields)}
      </React.Fragment>
    }

    if (section.type === "collapsable" || section.type === "collapsable-start-closed") {
      return <SectionPanel.Panel
        key={section.key}
        id={section.key}
        supportArticleId={section.supportArticleId}
        header={section.hideTitle ? null : <SectionTemplateHeader subTitle={section.subTitle}>{section.title}</SectionTemplateHeader>}
        collapsible={{
          start: section.type === "collapsable-start-closed" ? "closed" : "open",
          uniqueRowId: section.key,
          persist: true,
        }}
      >
        {renderFormSectionFields(section.fields)}
      </SectionPanel.Panel>;
    }
    return <SectionPanel.Panel
      key={section.key}
      id={section.key}
      supportArticleId={section.supportArticleId}
      header={section.hideTitle ? null : <SectionTemplateHeader subTitle={section.subTitle}>{section.title}</SectionTemplateHeader>}
    >
      {renderFormSectionFields(section.fields)}
    </SectionPanel.Panel>
  }

  return <SectionPanel.Section key="section">
    {visibleSections.map(section => {
      if (section.type === "custom") {
        return section.render();
      }

      return renderFormSection(section);
    })}

  </SectionPanel.Section>
}